// Soglie di avviso scadenze (giorni prima della data di scadenza)
export const WARNING_DAYS_PERSONAL = 90;  // Armadietto personale (F13)
export const WARNING_DAYS_HR = 180;        // Dashboard HR (F14)

export type ExpiryStatus = 'Idoneo' | 'InScadenza' | 'NonIdoneo' | 'NonInserita';

export function getExpiryStatus(expiry: string | null | undefined, warningDays: number): ExpiryStatus {
  if (!expiry) return 'NonInserita';
  const now = new Date();
  const exp = new Date(expiry);
  const daysDiff = Math.round((exp.getTime() - now.getTime()) / 86400000);
  if (daysDiff < 0) return 'NonIdoneo';
  if (daysDiff <= warningDays) return 'InScadenza';
  return 'Idoneo';
}
